import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class ApiRestService {

  constructor(private apiservice: ApiService) { }

  public getJasonRestApi(apiCall, apiBaseName) {
    return this.apiservice.getJsonRestApi(apiCall, apiBaseName);
  }

  public postJasonRestApi(apiCall, apiBaseName, content) {
    return this.apiservice.postJsonRestApi(apiCall, apiBaseName, content);
  }

  public uploadFile(apiCall, theFile, formData) {
    return this.apiservice.uploadFile(apiCall, theFile, formData);
  }

  public getPDFStream(apiCall) {
    return this.apiservice.getPDFStream(apiCall);
  }

  public getPDFStream_CharterSchool(apiCall) {
    return this.apiservice.getPDFStream_CharterSchool(apiCall);
  }
}
